/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_CompleteInputs */

const en_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loudness normalization complete`)
};

const fr_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalisation du loudness terminée`)
};

const de_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautheitsnormalisierung abgeschlossen`)
};

const it_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalizzazione del volume completata`)
};

const ru_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нормализация громкости завершена.`)
};

const es_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalización de sonoridad completada`)
};

const zh_cn2_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响度归一化完成`)
};

const ja_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音量の正規化が完了しました`)
};

const hi_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ध्वनि स्तर का सामान्यीकरण पूरा हुआ`)
};

const pt_pt2_audio_description_export_loudness_complete = /** @type {(inputs: Audio_Description_Export_Loudness_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalização de intensidade sonora concluída`)
};

/**
* | output |
* | --- |
* | "Loudness normalization complete" |
*
* @param {Audio_Description_Export_Loudness_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_complete = /** @type {((inputs?: Audio_Description_Export_Loudness_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_complete(inputs)
	if (locale === "de") return de_audio_description_export_loudness_complete(inputs)
	if (locale === "it") return it_audio_description_export_loudness_complete(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_complete(inputs)
	if (locale === "es") return es_audio_description_export_loudness_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_complete(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_complete(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_complete(inputs)
	return en_audio_description_export_loudness_complete(inputs)
});